export default __webpack_public_path__ + "media/images/logo-301c772172a575ae84ddf7b9bb1b21eb.svg";